// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/payments/firstparty/v5/get_payment.proto

/* eslint-disable */
import { ApiPayment } from "./payment";

/** Request to retrieve a payment by ID */
export interface ApiGetPaymentByIdRequest {
  /** ID of the payment */
  readonly paymentId: string;
}

/** Response containing the retrieved payment */
export interface ApiGetPaymentByIdResponse {
  /** The payment data */
  readonly payment: ApiPayment | null;
}

export const ApiGetPaymentByIdRequest: MessageFns<ApiGetPaymentByIdRequest> = {
  fromJSON(object: any): ApiGetPaymentByIdRequest {
    return { paymentId: isSet(object.payment_id) ? globalThis.String(object.payment_id) : "" };
  },

  toJSON(message: ApiGetPaymentByIdRequest): unknown {
    const obj: any = {};
    if (message.paymentId !== undefined && message.paymentId !== null) {
      obj.payment_id = message.paymentId;
    }
    return obj;
  },
};

export const ApiGetPaymentByIdResponse: MessageFns<ApiGetPaymentByIdResponse> = {
  fromJSON(object: any): ApiGetPaymentByIdResponse {
    return { payment: isSet(object.payment) ? ApiPayment.fromJSON(object.payment) : null };
  },

  toJSON(message: ApiGetPaymentByIdResponse): unknown {
    const obj: any = {};
    if (message.payment !== undefined && message.payment !== null) {
      obj.payment = ApiPayment.toJSON(message.payment);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
